import { Box, Stack, type SxProps, Tabs, type Theme } from '@mui/material';
import { type SyntheticEvent, useState } from 'react';
import { PlansTab } from 'src/pages/Settings/memberships/components/plans-tab/plans-tab';
import { StyleTab } from 'src/pages/Settings/memberships/components/style-tab';
import { MembershipsConfigTab } from 'src/pages/Settings/memberships/styled';
import { TabValues } from 'src/pages/Settings/memberships/types';

type TabValue = TabValues;

interface ConfigTabsProps {
  onTabChange?: (tabIndex: TabValue) => void;
  readOnly: boolean;
}

const configTabsHeaderSx: SxProps<Theme> = {
  borderBottom: (theme) => `${theme.typography.pxToRem(1)} solid ${theme.palette.divider}`,
};

const tabsIndicatorSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.custom.OV.sys.primary,
};

const tabsRootSx: SxProps<Theme> = {
  minHeight: '3rem',
};

const tabSlotProps = {
  indicator: {
    sx: tabsIndicatorSx,
  },
};

export const ConfigTabs = ({ onTabChange, readOnly }: ConfigTabsProps) => {
  const [activeTab, setActiveTab] = useState<TabValue>(TabValues.Plans);

  const handleTabChange = (_: SyntheticEvent, nextTab: TabValue) => {
    if (nextTab === activeTab) {
      return;
    }
    setActiveTab(nextTab);
    onTabChange?.(nextTab);
  };

  return (
    <Stack height="100%" flex={1} direction="column">
      <Box sx={configTabsHeaderSx}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="standard"
          slotProps={tabSlotProps}
          sx={tabsRootSx}
        >
          <MembershipsConfigTab label="Plans" value={TabValues.Plans} />
          <MembershipsConfigTab label="Style" value={TabValues.Style} />
        </Tabs>
      </Box>

      <Box flex={1} overflow="auto" py={2}>
        {activeTab === TabValues.Plans ? <PlansTab readOnly={readOnly} /> : null}

        {activeTab === TabValues.Style ? <StyleTab readOnly={readOnly} /> : null}
      </Box>
    </Stack>
  );
};
